export default __webpack_public_path__ + "static/media/weather-travel.88e436a3.png";